// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-components-EntityAnchor-EntityAnchor-module__box--ZNL_U {
  display: flex;
  flex-direction: column;
  padding: 16px 16px 24px;
}
.src-components-EntityAnchor-EntityAnchor-module__item--Gq0xv {
  border-left: thin solid rgba(0, 0, 0, 0.06);
  padding: 5px 0 5px 16px;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 160%;
}
.src-components-EntityAnchor-EntityAnchor-module__item--Gq0xv.src-components-EntityAnchor-EntityAnchor-module__active--BVK1G {
  color: #e43d00;
  border-left-color: #e43d00;
}
/*# sourceMappingURL=EntityAnchor.module.css.map */`, "",{"version":3,"sources":["webpack://./EntityAnchor.module.less","webpack://./src/components/EntityAnchor/EntityAnchor.module.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;ACCF;ADCA;EACE,2CAAA;EACA,uBAAA;EACA,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;ACCF;ADCE;EACE,cAAA;EACA,0BAAA;ACCJ;AACA,kDAAkD","sourcesContent":[".box {\n  display: flex;\n  flex-direction: column;\n  padding: 16px 16px 24px;\n}\n.item {\n  border-left: thin solid rgba(0, 0, 0, 0.06);\n  padding: 5px 0 5px 16px;\n  color: rgba(0, 0, 0, 0.85);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 160%;\n\n  &.active {\n    color: #e43d00;\n    border-left-color: #e43d00;\n  }\n}\n",".box {\n  display: flex;\n  flex-direction: column;\n  padding: 16px 16px 24px;\n}\n.item {\n  border-left: thin solid rgba(0, 0, 0, 0.06);\n  padding: 5px 0 5px 16px;\n  color: rgba(0, 0, 0, 0.85);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 160%;\n}\n.item.active {\n  color: #e43d00;\n  border-left-color: #e43d00;\n}\n/*# sourceMappingURL=EntityAnchor.module.css.map */"],"sourceRoot":""}]);
// Exports
export var box = `src-components-EntityAnchor-EntityAnchor-module__box--ZNL_U`;
export var item = `src-components-EntityAnchor-EntityAnchor-module__item--Gq0xv`;
export var active = `src-components-EntityAnchor-EntityAnchor-module__active--BVK1G`;
export default ___CSS_LOADER_EXPORT___;
